import { Component, Input, OnChanges, SimpleChanges, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiEmptyImageComponent } from '../../shared/components/ui-empty-image.component';

@Component({
    selector: 'app-product-gallery',
    standalone: true,
    imports: [CommonModule, UiEmptyImageComponent],
    template: `
    <div class="flex flex-col-reverse md:flex-row gap-4">
      <div *ngIf="imagenes().length > 1"
        class="flex md:flex-col gap-3 overflow-x-auto md:overflow-y-auto md:max-h-[560px] pb-1 md:pb-0 md:pr-1 shrink-0">
        <button
          *ngFor="let img of imagenes(); let i = index"
          type="button"
          (click)="activo.set(i)"
          class="relative w-20 h-20 rounded-2xl overflow-hidden border-2 bg-white shrink-0 cursor-pointer transition-all hover:opacity-100"
          [class.border-rose-500]="i === activo()"
          [class.border-gray-100]="i !== activo()"
          [class.opacity-60]="i !== activo()"
        >
          <img [src]="img" [alt]="altText + ' ' + (i + 1)" (error)="fallar(img)" loading="lazy" decoding="async" class="w-full h-full object-cover" />
        </button>
      </div>

      <div class="relative flex-1 aspect-square w-full rounded-[2rem] overflow-hidden bg-white border border-gray-100 shadow-sm">
        <app-ui-empty-image *ngIf="imagenes().length === 0" iconClass="w-16 h-16"></app-ui-empty-image>

        <img
          *ngFor="let img of imagenes(); let i = index"
          [src]="img"
          [alt]="altText"
          (error)="fallar(img)"
          loading="lazy" decoding="async"
          class="absolute inset-0 w-full h-full object-cover object-center transition-opacity duration-500"
          [class.opacity-100]="i === activo()"
          [class.opacity-0]="i !== activo()"
        />

        <button
          *ngIf="imagenes().length > 1"
          type="button"
          (click)="anterior()"
          class="absolute left-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/90 hover:bg-white shadow-md flex items-center justify-center cursor-pointer"
        >
          <svg class="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
          </svg>
        </button>

        <button
          *ngIf="imagenes().length > 1"
          type="button"
          (click)="siguiente()"
          class="absolute right-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/90 hover:bg-white shadow-md flex items-center justify-center cursor-pointer"
        >
          <svg class="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
          </svg>
        </button>

        <span *ngIf="imagenes().length > 1"
          class="absolute bottom-4 right-4 text-[11px] font-bold bg-gray-900/60 text-white px-2.5 py-1 rounded-full">
          {{ activo() + 1 }} / {{ imagenes().length }}
        </span>
      </div>
    </div>
    `
})
export class ProductGalleryComponent implements OnChanges {
    @Input({ required: true }) images: string[] = [];
    @Input() altText: string = 'Producto';

    imagenes = signal<string[]>([]);
    activo = signal(0);

    ngOnChanges(changes: SimpleChanges) {
        if (changes['images']) {
            this.imagenes.set((this.images ?? []).filter((url) => !!url));
            this.activo.set(0);
        }
    }

    anterior() {
        const total = this.imagenes().length;
        if (total < 2) {
            return;
        }
        this.activo.update((i) => (i - 1 + total) % total);
    }

    siguiente() {
        const total = this.imagenes().length;
        if (total < 2) {
            return;
        }
        this.activo.update((i) => (i + 1) % total);
    }

    fallar(url: string) {
        const restantes = this.imagenes().filter((u) => u !== url);
        this.imagenes.set(restantes);
        if (this.activo() >= restantes.length) {
            this.activo.set(0);
        }
    }
}
